import { IPDASetting } from '../models/IPDASetting.model';
import api from './wasteManagementClient';
import { wasteManagementUrls as urls } from '../appConfig';

export abstract class PdaSettingsService {
  public static async GetPdaSettings(
    ignoreCache = false,
  ): Promise<Array<IPDASetting>> {
    try {
      const response = await api.get(urls.pdaSettings, {
        cache: { ignoreCache },
      });
      return response.status === 200 ? response.data : [];
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  }

  public static async CreateNewPdaSetting(
    created: IPDASetting,
  ): Promise<IPDASetting> {
    try {
      const response = await api.post(urls.pdaSettings, created);
      return response.status === 200 ? response.data : null;
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  }

  public static async UpdatePDASetting(
    updated: IPDASetting,
  ): Promise<IPDASetting> {
    try {
      const response = await api.put(urls.pdaSettings, updated);
      return response.status === 200 ? response.data : null;
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  }
}
